const KEY = "cgp_cookie_consent";
const EVENT = "cgp-consent-change";

export const getConsent = () => {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    if (value === null) window.localStorage.removeItem(KEY);
    else window.localStorage.setItem(KEY, value);
  } catch {}
  window.dispatchEvent(new Event(EVENT));
};

export const CONSENT_EVENT = EVENT;
